/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Compare_OthersInputs */

const en_why_listening_compare_others = /** @type {(inputs: Why_Listening_Compare_OthersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Other apps`)
};

const es_why_listening_compare_others = /** @type {(inputs: Why_Listening_Compare_OthersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otras apps`)
};

/**
* | output |
* | --- |
* | "Other apps" |
*
* @param {Why_Listening_Compare_OthersInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_compare_others = /** @type {((inputs?: Why_Listening_Compare_OthersInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Compare_OthersInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_compare_others(inputs)
	return en_why_listening_compare_others(inputs)
});